export const FlashIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.65333 0C2.98 0 0 2.98 0 6.65333C0 10.3267 2.98 13.3067 6.65333 13.3067C10.3267 13.3067 13.3067 10.3267 13.3067 6.65333C13.3067 2.98 10.3267 0 6.65333 0ZM6.30667 11.9867V7.81333H3.98667L7.32 1.32V5.49333H9.55333L6.30667 11.9867Z"
      fill="#1F272E"
    />
  </svg>
);
